import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { CHANNEL } from '../config';


export const channelInterceptor: HttpInterceptorFn = (req, next) => {
	const authRequest = addChannelHeader(req);
	return next(authRequest);
};
const addChannelHeader = (req: HttpRequest<unknown>) => {
	const channel = inject(CHANNEL);
	return req.clone({
		headers: req.headers.set('channel', channel),
	});
};
